import { AttributeDefinition, AttributeType } from 'domain/experiment/attribute';

export const DEFAULT_FILE_SERIES_CONFIG: FileSeriesWidgetOptions = {
  defaultStep: undefined,
};

export const compatibleAttributeTypes: AttributeType[] = ['fileSeries'];

export const prefillAttributes: AttributeDefinition[] = [
  { name: 'step', type: 'floatSeries', predefined: true },
];

export type FileSeriesWidgetOptions = {
  defaultStep?: number;
};
